import React from 'react';
import _ from "lodash";
import * as echarts from 'echarts~5';
import style from './index.module.scss';
import { DEFAULT_OPTION, DEFAULT_LINE_COLOR } from './utils';
import { Spin } from 'antd';
import DomResize from 'components/DomResize';

export default class Comp extends React.Component {

    constructor(props) {
        super(props);

        const hideIdList = (props?.config?.meta_list ?? [])
            .filter(({ tagName }) =>
                (props?.config?.blackListHide ?? []).includes(tagName)
            )
            .map(({ id }) => id);

        this.state = {
            hideIdList
        };

        this.chartInstance = null;
        this.prevConfig = null;
        this.prevLineData = null;
    }

    componentDidMount() {
        this.updateChart(this.props.config, this.props.lineData);
    }

    componentDidUpdate(prevProps, prevState) {
        const configChanged = prevProps.config !== this.props.config;
        const dataChanged = prevProps.lineData !== this.props.lineData;
        const hideChanged = prevState.hideIdList !== this.state.hideIdList;

        if (configChanged || dataChanged || hideChanged) {
            this.updateChart(this.props.config, this.props.lineData);
        }
    }

    componentWillUnmount() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    }

    updateChart = (config, data) => {
        if (!this.chartNode || !config) return;

        let option = _.cloneDeep(DEFAULT_OPTION);
        const { hideIdList } = this.state;

        option.series = (config?.meta_list ?? [])
            .filter(({ id }) => !hideIdList.includes(id))
            .map((item) => {

                const item_data = data?.[item?.tag_name ?? null] ?? [];

                return Object.assign({
                    name: item?.name ?? "--",
                    data: item_data.map(([v, t]) => [t, v]),
                    type: item?.type === "bar" ? "bar" : 'line',
                    itemStyle: {
                        color: item?.color ?? DEFAULT_LINE_COLOR,
                    },
                    yAxisIndex: item?.rightY === true ? 1 : 0,
                    symbol: item?.point === '1' ? 'emptyCircle' : 'none',
                }, item?.type === 'step-line' ? { step: 'start' } : {});
            });

        const yProps = config?.y_props ?? null;

        const hasLeftData = option.series?.some?.(({ yAxisIndex }) => yAxisIndex === 0);
        const hasRightData = option.series?.some?.(({ yAxisIndex }) => yAxisIndex === 1);

        if (option?.yAxis?.[0]) {
            option.yAxis[0] = Object.assign({}, option.yAxis[0], hasLeftData ? {
                ...(typeof yProps?.main_max === 'number' ? { max: yProps.main_max } : {}),
                ...(typeof yProps?.main_min === 'number' ? { min: yProps.main_min } : {})
            } : {});
        }

        if (option?.yAxis?.[1]) {
            option.yAxis[1] = Object.assign({}, option.yAxis[1], hasRightData ? {
                ...(typeof yProps?.second_max === 'number' ? { max: yProps.second_max } : {}),
                ...(typeof yProps?.second_min === 'number' ? { min: yProps.second_min } : {})
            } : {});
        }

        if (!this.chartInstance) {
            this.chartInstance = echarts.init(this.chartNode);
        }

        this.chartInstance.clear();
        this.chartInstance.setOption(option);
    }

    refFUnc = (refNode) => {
        this.chartNode = refNode;
    }

    onResize = () => {
        if (this.chartInstance) {
            this.chartInstance.resize();
        }
    }

    hide = (item) => () => {
        const { hideIdList } = this.state;

        const nHideIdList = hideIdList.includes(item.id)
            ? hideIdList.filter(v => v !== item.id)
            : hideIdList.concat(item.id);

        this.setState({ hideIdList: nHideIdList });
    }

    render() {
        const { config, loading } = this.props;
        const { hideIdList } = this.state;

        return (
            <div className={style["wrapper"]}>
                <div className="header">
                    <div className="colored_bar" />
                    <div className="title">{config?.title ?? "--"}</div>

                    <div style={{ marginLeft: "auto" }} />

                    <div className="right">
                        {(config?.meta_list ?? []).map((item, index) => (
                            <div
                                key={item.id || index}
                                className={"item" + (hideIdList.includes(item.id) ? ' hide' : '')}
                                onClick={this.hide(item)}
                            >
                                <div
                                    className="colored_line"
                                    style={{ backgroundColor: item.color ?? DEFAULT_LINE_COLOR }}
                                />
                                <div className="item_title">{item.name ?? "--"}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="content">
                    <div className="resize_wrapper">
                        <DomResize onResize={this.onResize} />
                    </div>

                    <div
                        ref={this.refFUnc}
                        style={{ height: '100%', position: 'relative' }}
                    />
                </div>

                {loading === true && (
                    <div style={{
                        position: 'absolute',
                        top: 0, right: 0, bottom: 0, left: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255,255,255,0.7)'
                    }}>
                        <Spin />
                    </div>
                )}
            </div>
        );
    }
}